<template>
    <TopSection class="checkout-intro">
        <template v-slot:header>
            {{ $t('Checkout.intro.headerDefault') }}
        </template>

        <template v-slot:text>
            <translate v-if="hideVoucherProtection" path="Checkout.intro.textWithoutProtection">
                <template v-slot:title>
                    <strong>{{ productTitle }}</strong>
                </template>
            </translate>
            <translate v-else path="Checkout.intro.text">
                <template v-slot:title>
                    <strong>{{ productTitle }}</strong>
                </template>
            </translate>

            <VoucherProtection v-if="!hideVoucherProtection" class="voucher-protection d-inline-flex">
                <IconSvg filepath="info.svg" class="info-sign" />
            </VoucherProtection>
        </template>
    </TopSection>
</template>

<script>
import TopSection from '@/components/checkout/TopSection';
import VoucherProtection from '@/components/VoucherProtection';

export default {
    name: 'CheckoutIntro',
    components: {
        TopSection,
        VoucherProtection
    },
    props: {
        productTitle: String,
        hideVoucherProtection: Boolean
    }
};
</script>

<style scoped lang="scss">
.checkout-intro {
    p {
        max-width: 680px;
    }

    .voucher-protection {
        display: inline-flex;
        cursor: help;
        vertical-align: middle;
    }

    .info-sign {
        stroke: var(--body-color);
        font-size: 18px;
        fill: none;
        stroke-width: 1.5px;
    }
}
</style>
